import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import copyIcon from '../../../../../_metronic/assets/images/svg/data-room/copy-icon-white.svg'
import {getShareLink} from '../../core/_requests'
import {toast} from 'react-toastify'
import {Spinner} from '../../../widgets/components/General/Spinner'
import {useMoveToFolderData} from '../../core/FileToFolderAuth'

export const LinkCreatedModal = ({
  linkId,
  onClose,
  dataRoomId,
  contentId,
}: {
  linkId: number | null
  onClose: any
  dataRoomId: number
  contentId: number
}) => {
  const {formatMessage} = useIntl()
  const [shareLinkApiLoading, setShareLinkApiLoading] = useState(false)
  const [shareLinkApiData, setShareLinkApiData] = useState<any>([])
  const {linkCreatedModal, setLinkCreatedModal} = useMoveToFolderData()

  const getShareLinkByShareLinkId = async () => {
    try {
      setShareLinkApiLoading(true)
      if (linkId) {
        const {
          data: {data, success, errors},
        } = await getShareLink(+linkId)
        if (success) {
          setShareLinkApiData(data)
          setLinkCreatedModal(true)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setShareLinkApiLoading(false)
    }
  }

  useEffect(() => {
    getShareLinkByShareLinkId()
  }, [linkId]) // eslint-disable-line react-hooks/exhaustive-deps

  const copyLinkToClipboard = (link: string) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.success(formatMessage({id: 'Link copied!'}))
      })
      .catch(() => {
        toast.error(formatMessage({id: 'Failed to copy link to clipboard'}))
      })
  }

  return (
    <>
      {shareLinkApiLoading ? <Spinner /> : null}
      {shareLinkApiData && shareLinkApiData.uuid && shareLinkApiData?.account?.name && (
        <div
          className={`modal fade link-created-modal-wrapper ${linkCreatedModal ? 'show' : ''}`}
          id='LinkCreatedModal'
          aria-labelledby='LinkCreatedModalLabel'
          aria-hidden='true'
          style={{display: linkCreatedModal ? 'block' : 'none'}}
        >
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title dark_text_color' id='LinkCreatedModalLabel'>
                  {formatMessage({id: 'Your link has been created'})}
                </h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={onClose}
                  data-bs-dismiss='modal'
                  aria-label='Close'
                ></button>
              </div>
              <div className='modal-body'>
                <p className='mb-0 dark_text_color'>
                  {formatMessage({
                    id: 'Copy and paste the link below into an email or wherever you want to send it',
                  })}
                </p>
                <div className='share-link-box'>
                  <p className='mb-0 dark_text_color'>
                    {dataRoomId ? (
                      <span>{`${window.location.origin}/data-rooms/public/${shareLinkApiData.uuid}`}</span>
                    ) : (
                      <span>{`${window.location.origin}/contents/public/${shareLinkApiData.uuid}`}</span>
                    )}
                  </p>
                </div>
                <div className='d-flex justify-content-center mb-7'>
                  <button
                    type='button'
                    className='btn btn-primary flex-grow-1 flex-md-grow-0'
                    onClick={() =>
                      copyLinkToClipboard(
                        dataRoomId
                          ? `${window.location.origin}/data-rooms/public/${shareLinkApiData.uuid}`
                          : `${window.location.origin}/contents/public/${shareLinkApiData.uuid}`
                      )
                    }
                  >
                    <img src={copyIcon} alt='' />
                    <p className='mb-0 text-white d-inline '>
                      {formatMessage({id: 'Click to copy link'})}
                    </p>
                  </button>
                </div>

                <p className='mb-0 dark_text_color'>
                  {`${formatMessage({id: 'The link belongs to '})} ${
                    shareLinkApiData?.account?.name
                  }  ${formatMessage({id: 'account.'})}`}
                </p>
                <hr />
              </div>
              <div className='modal-footer'>
                <button
                  data-bs-dismiss='modal'
                  className='btn btn-light flex-grow-1 flex-md-grow-0'
                  onClick={onClose}
                >
                  <p className='mb-0 dark_text_color'>{formatMessage({id: 'Done'})}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
